export default __webpack_public_path__ + "0895871a259135abf93f0c32b9ff631b.png";